import React, { Component, Suspense } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom'
import DefaultNavbar from './DefaultNavbar';
import DefaultFooter from './DefaultFooter';
import routes from '../../routes';

export default class DefaultLayout extends Component{
    loading = () => <div className="animated fadeIn pt-1 text-center"><div className="sk-spinner sk-spinner-pulse"></div></div>;

    render(){
        return(
            <div className="app">
                <DefaultNavbar/>
                <div className="app-body">
                    <main>
                        {/* <Container fluid> */}
                            <Suspense fallback={this.loading()}>
                                <Switch>
                                    {routes.map((route, idx) => {
                                        return route.component ? (
                                            <Route
                                                key={idx}
                                                path={route.path}
                                                exact={route.exact}
                                                name={route.name}
                                                render={props => (
                                                <route.component {...props} />
                                            )} />
                                        ) : (null);
                                    })}
                                    <Redirect to="/home"/>
                                </Switch>
                            </Suspense>
                        {/* </Container> */}
                    </main>
                </div>
                <DefaultFooter/>
            </div>
        )
    }

}